const card = () => {

    jQuery(".card .btn-link").on("click", function() {

        let $card = jQuery(this).closest(".card");

        jQuery(this).toggleClass("collapsed");
        $card.find(".card-content").toggleClass("show");

        let count = jQuery(".card .btn-link").length;
        let has_class = 0;
        jQuery(".card .btn-link").each(function(i, el) {

            if (jQuery(el).hasClass("collapsed")) {
                has_class++;
            }

        });

        if (count <= has_class) {
            jQuery("#expand_all_cards").html("Expand all").removeClass("img-collapsed");
        }

        else if (has_class == 0) {
            jQuery("#expand_all_cards").html("Collapse all").addClass("img-collapsed");
        }

    });

    jQuery("#expand_all_cards").on("click", function() {

        if (jQuery(this).html() == "Expand all") {

            jQuery(".card .btn-link").removeClass("collapsed");
            jQuery(".card-content").addClass("show");

            jQuery(this).html("Collapse all").addClass("img-collapsed");

        }

        else {

            jQuery(".card .btn-link").addClass("collapsed");
            jQuery(".card-content").removeClass("show");

            jQuery(this).html("Expand all").removeClass("img-collapsed");

        }

    });

};